import { useState } from "react";
import Lightbox from "./Lightbox";

const PortfolioSection = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const projects = [
    {
      image: "https://customer-assets.emergentagent.com/job_ttwood-villard/artifacts/tvbrmtfz_Messenger_creation_295BF40A-61B8-48D0-943F-9610E40EF102.jpg",
      title: "Cuisine en bois clair",
      category: "Aménagement intérieur",
      size: "large",
    },
    {
      image: "https://customer-assets.emergentagent.com/job_ttwood-villard/artifacts/mxnb7mzx_Messenger_creation_779E2DAF-F069-4BC5-90D9-B44523C5D1FA.jpg",
      title: "Claustra sur mesure",
      category: "Menuiserie sur mesure",
      size: "tall",
    },
    {
      image: "https://customer-assets.emergentagent.com/job_ttwood-villard/artifacts/fi3l0sno_Messenger_creation_72CF6FA6-286B-41EB-BF5C-07585FC79F92.jpg",
      title: "Cuisine moderne en chêne",
      category: "Aménagement intérieur",
      size: "normal",
    },
    {
      image: "https://customer-assets.emergentagent.com/job_ttwood-villard/artifacts/6nmd9s3a_Messenger_creation_76F43F20-971F-4975-93D5-78054F114039.jpg",
      title: "Table basse artisanale",
      category: "Mobilier",
      size: "normal",
    },
    {
      image: "https://customer-assets.emergentagent.com/job_ttwood-villard/artifacts/7ica5i0e_Messenger_creation_3B293E1C-0230-4356-BC79-675ABFAEAE04.jpg",
      title: "Tête de lit et luminaires",
      category: "Aménagement chambre",
      size: "normal",
    },
    {
      image: "https://customer-assets.emergentagent.com/job_ttwood-villard/artifacts/e9y83udd_Messenger_creation_3A7DBEEE-14AE-443B-B552-57A89C62446E.jpg",
      title: "Cuisine avec plan de travail bois",
      category: "Aménagement intérieur",
      size: "normal",
    },
    {
      image: "https://customer-assets.emergentagent.com/job_ttwood-villard/artifacts/etyqz75o_Messenger_creation_4A16410F-52F1-4EF2-B67F-11A32F001F48.jpg",
      title: "Bibliothèque sur mesure",
      category: "Mobilier",
      size: "normal",
    },
    {
      image: "https://customer-assets.emergentagent.com/job_ttwood-villard/artifacts/1g7qou9j_Messenger_creation_F1ED1BE7-601F-4C24-A66C-F8D79161D5EC.jpg",
      title: "Meuble TV et claustra",
      category: "Aménagement intérieur",
      size: "normal",
    },
  ];

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
  };

  return (
    <section
      id="realisations"
      className="py-20 md:py-32 bg-warm-cream relative"
      data-testid="portfolio-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-forest-green font-medium text-sm uppercase tracking-wider">
            Nos Réalisations
          </span>
          <h2 
            className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-deep-oak mt-3 mb-6"
            data-testid="portfolio-title"
          >
            Des Projets qui Inspirent
          </h2>
          <p className="text-text-secondary text-base md:text-lg">
            Découvrez quelques-unes de nos créations. Chaque pièce raconte une 
            histoire et témoigne de notre engagement envers l'excellence.
          </p>
        </div>

        {/* Bento Grid */}
        <div className="bento-grid">
          {projects.map((project, index) => (
            <div
              key={index}
              className={`bento-item cursor-pointer ${
                project.size === "large" ? "bento-large" : ""
              } ${project.size === "wide" ? "bento-wide" : ""} ${
                project.size === "tall" ? "bento-tall" : ""
              }`}
              onClick={() => openLightbox(index)}
              data-testid={`portfolio-item-${index}`}
            >
              <img 
                src={project.image} 
                alt={`${project.title} - ${project.category} - TT Wood menuiserie Villard-Bonnot`}
                loading="lazy"
                decoding="async"
                className={project.title === "Table basse artisanale" ? "object-contain bg-warm-cream" : ""}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
                <span className="text-white/70 text-xs uppercase tracking-wider mb-1">
                  {project.category}
                </span>
                <h3 className="text-white font-heading text-xl font-semibold">
                  {project.title}
                </h3>
              </div>
            </div>
          ))}
        </div>

        {/* Instagram Link */}
        <div className="text-center mt-12">
          <p className="text-text-secondary mb-4">
            Découvrez plus de réalisations sur notre Instagram
          </p>
          <a
            href="https://www.instagram.com/ttwood38/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-deep-oak hover:text-forest-green transition-colors font-medium"
            data-testid="instagram-link"
          >
            <svg
              className="w-5 h-5"
              fill="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                clipRule="evenodd"
              />
            </svg>
            @ttwood38
          </a>
        </div>
      </div>

      {/* Lightbox */}
      <Lightbox
        images={projects}
        currentIndex={currentImageIndex}
        isOpen={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
        onNavigate={setCurrentImageIndex}
      />
    </section>
  );
};

export default PortfolioSection;
